// eslint-disable-next-line import/no-anonymous-default-export
export default {
  data: [
    {
      RollNo: "President",
      Name: "Prof. Jitendra Mahakud",
      Post: "President",
      img: "President.png",
      Facebook: "",
      LinkedIn: "https://www.linkedin.com/in/jitendra-mahakud-26463b109/",
      Contact: "",
      Email: "jmahakud@hss.iitkgp.ac.in",
      "Institue ids": "https://www.iitkgp.ac.in/department/PH/faculty/ph-singh",
      "Institute mail ids": "",
    },
    {
      RollNo: " Associate President",
      Name: "Prof. Arijit De",
      Post: "Associate President",
      img: "AssociatePresident.jpg",
      Facebook: "",
      LinkedIn: "",
      Contact: "",
      Email: "arijit@ece.iitkgp.ac.in",
      "Institue ids": "https://www.iitkgp.ac.in/department/EC/faculty/ec-arijit",
      "Institute mail ids": "",
    },
    {
      RollNo: "Honorary Treasurer",
      Name: "Prof. Jayanta Chakraborty",
      Post: "Honorary Treasurer",
      img: "HonoraryTreasurer.png",
      Facebook: "https://www.facebook.com/jayanta.chakraborty.14855",
      LinkedIn: "https://www.linkedin.com/in/dr-jayanta-chakraborty-3567a913/",
      Contact: "",
      Email: "jayanta@che.iitkgp.ac.in",
      "Institue ids":
        "https://www.iitkgp.ac.in/department/CH/faculty/ch-jayanta",
      "Institute mail ids": "",
    },
    {
      RollNo: "20MF3FP34",
      Name: "Samarth Singh",
      Category: "VP",
      Post: "Vice President",
      img: "20MF3FP34.jpeg",
      Contact: 8004125928,
      Email: "samarthsingh2003@gmail.com",
      "Insti Email": "samarth2003@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/samarth2003",
      LinkedIn: "https://www.linkedin.com/in/samarth-singh-2003/",
    },
    {
      RollNo: "21EC10040",
      Name: "Varsha Kotagiri ",
      Category: "General Secretary",
      Post: "General Secretary Social and Cultural ",
      img: "21EC10040.jpg",
      Contact: 7842710926,
      Email: "varshakotagiri.iitkgp@gmail.com",
      "Insti Email": "varshakotagiri1503@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/varshakotagiri03?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/varsha-kotagiri-633155230",
    },
    {
      RollNo: "21CE30026",
      Name: "Sachin Kumar Repswal",
      Category: "General Secretary",
      Post: "General Secretary Social and Cultural",
      img: "21CE30026.jpg",
      Contact: 7737277761,
      Email: "sachinrepswal682@gmail.com",
      "Insti Email": "sachinrepswal2021@kgpian.iitkgp.ac.in ",
      Facebook:
        "https://www.facebook.com/profile.php?id=100074899233008&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/sachin-kumar-repswal-267768240",
    },
    {
      RollNo: "21BT30028",
      Name: "Soujanya Nayak ",
      Category: "General Secretary",
      Post: "General Secretary Sports and Games",
      img: "21BT30028.png",
      Contact: 7506136455,
      Email: "soujanya4013@gmail.com",
      "Insti Email": "soujanya@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/SoujanyaNayak4013?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/soujanyanayak",
    },
    {
      RollNo: "21EC10058",
      Name: "SSVKSS Jyothiraditya ",
      Category: "General Secretary",
      Post: "General Secretary Sports and Games",
      img: "21EC10058.jpg",
      Contact: 7675007236,
      Email: "jyothiraditya29@gmail.com ",
      "Insti Email": "jyothiradityas@kgpian.iitkgp.ac.in ",
      Facebook: "https://www.facebook.com/profile.php?id=100082880005752",
      LinkedIn: "https://www.linkedin.com/in/ssvkss-jyothiraditya-21200322b/",
    },
    {
      RollNo: "21IM30008",
      Name: "Jakkinapalli Satya Ravi Sujit ",
      Category: "General Secretary",
      Post: "General Secretary Students' Welfare ",
      img: "21IM30008.png",
      Contact: 9133535913,
      Email: "jsrsujit1634@gmail.com",
      "Insti Email": "jsrsujit@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100009358659751&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/jsr-sujit-525625223",
    },
    {
      RollNo: "21CE10059",
      Name: "Sapharu Veena Nikhita",
      Category: "General Secretary",
      Post: "General Secretary Students' Welfare",
      img: "21CE10059.jpg",
      Contact: 8331899522,
      Email: "vnsapharu22@gmail.com",
      "Insti Email": "vnsapharu@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100075559055537",
      LinkedIn: "https://www.linkedin.com/in/sapharu-veena-nikhita-4a08a5241/",
    },
    {
      RollNo: "21AG30013",
      Name: "Digvijay Singh",
      Category: "General Secretary",
      Post: "General Secretary Technology",
      img: "21AG30013.jpg",
      Contact: 8209522951,
      Email: "digvijaysingh172003@gmail.com",
      "Insti Email": "digvijaysingh172003@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100022993371763",
      LinkedIn: "https://www.linkedin.com/in/digvijay-singh-b95936231/",
    },
    {
      RollNo: "21MA10065",
      Name: "Vinayak Agarwal ",
      Category: "General Secretary",
      Post: "General Secretary Technology",
      img: "21MA10065.jpg",
      Contact: 9340273020,
      Email: "vinayakiit04@gmail.com",
      "Insti Email": "vinayak@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/411vinayak?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/vinayak-agarwal-11759222a",
    },
    {
      RollNo: "21MA10012 ",
      Name: "Anushka Aashvi",
      Category: "Nominated",
      Post: "Editor",
      img: "21MA10012.png",
      Contact: "7070007766",
      Email: "iamanushkaaashvi@gmail.com",
      "Insti Email": "anushkaaashvi@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/anushka.aashvi?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/anushka-aashvi-a976a6223",
      "": "",
    },
    {
      RollNo: "21ME10092",
      Name: "Vanshul Shikkewal ",
      Category: "Nominated",
      Post: "Editor",
      img: "21ME10092.png",
      Contact: "9479764751",
      Email: "vanshul.sikkewal@outlook.com",
      "Insti Email": "vanshul.shikkewal@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/vanshul.2723",
      LinkedIn: "https://www.linkedin.com/in/vanshul2723/",
      "": "",
    },
    {
      RollNo: "21EC30025",
      Name: "Irsh Vijayvargia",
      Category: "Nominated",
      Post: "Public Relations Chairman",
      img: "21EC30025.png",
      Contact: "9116515740",
      Email: "irsh.iitkgp@gmail.com",
      "Insti Email": "irsh@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100075290924188&mibextid=LQQJ4d",
      LinkedIn: "https://www.linkedin.com/in/irsh",
      "": "",
    },
    {
      RollNo: "21CH30031 ",
      Name: "Shreya Mishra ",
      Category: "Nominated",
      Post: "Institute Girl Sports' Nominee ",
      img: "21CH30031.png",
      Contact: "9475621028",
      Email: "mshreya1210@gmail.com",
      "Insti Email": "shreyamishra@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100074610314302&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/shreya-mishra-b057ba239",
      "": "",
    },
    {
      RollNo: "21IM10009",
      Name: "Arpit Bhardwaj",
      Category: "Nominated",
      Post: "Technology Coordinator",
      img: "21IM10009.png",
      Contact: "9761667733",
      Email: "arpitbhardwaj.iitkgp@gmail.com",
      "Insti Email": "proffapt@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100092350315439",
      LinkedIn: "https://linkedin.com/in/proffapt",
      "": "",
    },
    {
      RollNo: "21BT30018",
      Name: "Parth Gupta",
      Category: "Nominated",
      Post: "Technology Coordinator",
      img: "21BT30018.png",
      Contact: "7620821543",
      Email: "guptaparth.iitkgp@gmail.com",
      "Insti Email": "parthgupta@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/parth.gupta.1422409/",
      LinkedIn: "https://www.linkedin.com/in/parthgupta2510/",
    },
    {
      RollNo: "22CH10012",
      Name: "Ashwini Raj",
      Category: "Secretary",
      Post: "Secretary Films and Photography ",
      img: "22CH10012.jpg",
      Email: "ashwiniraj2020@gmail.com",
      Contact: 9798148081,
      "Insti Email": "ashwiniraj2022@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100086406498178&mibextid=LQQJ4d",
      LinkedIn: "https://www.linkedin.com/in/ashwini-raj-415b8a24b/",
    },
    {
      RollNo: "22MA10010",
      Name: "Atul Choudhary",
      Category: "Secretary",
      Post: "Secretary Fine Arts and Modelling",
      img: "22MA10010.jpg",
      Email: "atul.choudhary.gkh@gmail.com",
      Contact: 9694521292,
      "Insti Email": "atulchoudhary3574@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100088355522655&mibextid=LQQJ4d",
      LinkedIn: "https://www.linkedin.com/in/atul-choudhary-6a4767259",
    },
    {
      RollNo: "22HS10034",
      Name: "Malla Sampath Narayana",
      Category: "Secretary",
      Post: "Secretary Entertainment ",
      img: "22HS10034.jpeg",
      Email: "sampathnarayana890@gmail.com",
      Contact: 9492780324,
      "Insti Email": "sampath@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087514031714",
      LinkedIn: "https://www.linkedin.com/in/malla-sampath-b62002185/",
    },
    {
      RollNo: "22ME30042",
      Name: "Muskan",
      Category: "Secretary",
      Post: "Secretary Journal",
      img: "22ME30042.jpg",
      Email: "muskandhull1511@gmail.com ",
      Contact: 8570034215,
      "Insti Email": "muskandhull@kgpian.iitkgp.ac.in ",
      Facebook:
        "https://www.facebook.com/profile.php?id=100088041730069&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/muskandhull",
    },
    {
      RollNo: "22CE30022",
      Name: "Prajojeet Pradhan",
      Category: "Secretary",
      Post: "Secretary Culinary Arts",
      img: "22CE30022.jpg",
      Email: "prajoj123@gmail.com",
      Contact: 6371785118,
      "Insti Email": "prajojeet@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/pro.pradhan.395",
      LinkedIn: "https://www.linkedin.com/in/prajojeet-pradhan-b93284271/",
    },
    {
      RollNo: "22ME30063",
      Name: "Shreyansh Agrawal ",
      Category: "Secretary",
      Post: "Secretary Dramatics",
      img: "22ME30063.jpeg",
      Email: "shreyanshua59@gmail.com",
      Contact: 9302734160,
      "Insti Email": "shreyanshua59@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087340759849&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/shreyansh-agrawal-858948251",
    },
    {
      RollNo: "22GG10054",
      Name: "Yash Kumar Gupta ",
      Category: "Secretary",
      Post: "Secretary Literary",
      img: "22GG10054.jpg",
      Email: "yashgupta980452@gmail.com",
      Contact: 9123322981,
      "Insti Email": "Yash_ykg@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100009800100589&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/yash-kumar-gupta-b02a3919a",
    },
    {
      RollNo: "22HS10004",
      Name: "Aishwarya Maan Srivastava",
      Category: "Secretary",
      Post: "Secretary Tennis",
      img: "22HS10004.png",
      Email: "aishm7807@gmail.com",
      Contact: 7819960702,
      "Insti Email": "aishm7807@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087460456348&mibextid=ZbWKwL",
      LinkedIn:
        "https://www.linkedin.com/in/aishwarya-maan-srivastava-b883a1255",
    },
    {
      RollNo: "22PH10013",
      Name: "Bonthu Matthews",
      Category: "Secretary",
      Post: "Secretary Basketball",
      img: "22PH10013.jpg",
      Email: "matthewsms2729@gmail.com",
      Contact: 8688324518,
      "Insti Email": "matthews27@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/matthews.bonthu.7/",
      LinkedIn: "https://www.linkedin.com/in/matthews-bonthu-99b32719b/",
    },
    {
      RollNo: "22IM30015",
      Name: "Kanishk Raj Choudhary ",
      Category: "Secretary",
      Post: "Secretary Hockey",
      img: "22IM30015.jpg",
      Email: "kanishkrajchoudhary@gmail.com",
      Contact: 8228837412,
      "Insti Email": "krchoudhary@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/kanishk.raj.399826?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/kanishk-raj-choudhary-b6babb250",
    },
    {
      RollNo: "22PH10023",
      Name: "Kumar Anash ",
      Category: "Secretary",
      Post: "Secretary Gymnasium and Weightlifting",
      img: "22PH10023.png",
      Email: "Kumaranash2601@gmail.com",
      Contact: "70048 23149 ",
      "Insti Email": "Kumaranash@kgpian.iitkgp.ac.in",
      Facebook: "https://m.facebook.com/kumar.anash.92",
      LinkedIn: "https://www.linkedin.com/in/kumar-anash-b4961a204",
    },
    {
      RollNo: "22AG10020",
      Name: "Madhav Samdani",
      Category: "Secretary",
      Post: "Secretary Badminton",
      img: "22AG10020.jpg",
      Email: "Madhavsamdani@gmail.com ",
      Contact: 8619732955,
      "Insti Email": "Madhavsamdani@kgpian.iitkgp.ac.in ",
      Facebook:
        "https://www.facebook.com/profile.php?id=100086694198133&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/madhav-samdani-889505257",
    },
    {
      RollNo: "22AE10023",
      Name: "Mohit Laddha",
      Category: "Secretary",
      Post: "Secretary Aquatics",
      img: "22AE10023.jpg",
      Email: "mohitladdha21@gmail.com",
      Contact: 9967011152,
      "Insti Email": "mohitladdha21@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087173395179",
      LinkedIn: "https://www.linkedin.com/in/mohit-laddha-b72634259/",
    },
    {
      RollNo: "22AR10018",
      Name: "Priyanshu Raj",
      Category: "Secretary",
      Post: "Secretary Football",
      img: "22AR10018.png",
      Email: "rraj77780@gmail.com",
      Contact: 8917474977,
      "Insti Email": "rraj77780@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/priyanshu.rajsingh.98?mibextid=LQQJ4d",
      LinkedIn: "https://www.linkedin.com/in/priyanshu-raj-182600259",
    },
    {
      RollNo: "22MA10048",
      Name: "Rishabh Jain",
      Category: "Secretary",
      Post: "Secretary Indoor Game",
      img: "22MA10048.jpg",
      Email: "rishabhj2k20@gmail.com",
      Contact: 9958310683,
      "Insti Email": "rishabhj@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100088177823818&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/rishabh-jain-944800259",
    },
    {
      RollNo: "22MA10049",
      Name: "Rithika Venkatesan ",
      Category: "Secretary",
      Post: "Secretary Athletics",
      img: "22MA10049.png",
      Email: "rithika.venkatesan@gmail.com",
      Contact: 8123920040,
      "Insti Email": "rithika.venkatesan@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087517275380&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/rithika-venkatesan-3870a0271",
    },
    {
      RollNo: "22AR10022",
      Name: "Sameer",
      Category: "Secretary",
      Post: "Secretary Squash",
      img: "22AR10022.jpg",
      Email: "Im.sameer.rao@gmail.com",
      Contact: 9050999499,
      "Insti Email": "Im.sameer.rao@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100051446330662&mibextid=ZbWKwL",
      LinkedIn: "http://www.linkedin.com/in/sameer-yadav-888sam",
    },
    {
      RollNo: "22GG10047",
      Name: "Shreyansh Yadav",
      Category: "Secretary",
      Post: "Secretary Volleyball",
      img: "22GG10047.png",
      Email: "yadavshreyansh2001@gmail.com",
      Contact: 8354893943,
      "Insti Email": "shreyansh.work@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100086390442828&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/shreyansh-yadav-96a720256",
    },
    {
      RollNo: "22BT30031",
      Name: "Sushant Pandey",
      Category: "Secretary",
      Post: "Secretary Cricket",
      img: "22BT30031.jpg",
      Email: "sushantpandey2612004@gmail.com",
      Contact: 9031761175,
      "Insti Email": "sushantpandey2612004@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100088393021709&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/sushant-pandey-226504270",
    },
    {
      RollNo: "22CH10040",
      Name: "Mohit Gupta",
      Category: "Secretary",
      Post: "Secretary Community and Crisis",
      img: "22CH10040.jpg",
      Email: "mohitgupta4873@gmail.com",
      Contact: 7004378584,
      "Insti Email": "mohitgupta4873@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100009144215218&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/mohit-gupta-8607a026b",
    },
    {
      RollNo: "22CE30028",
      Name: "Swastik Kumar Das",
      Category: "Secretary",
      Post: "Secretary Academic Help",
      img: "22CE30028.png",
      Email: "swastikdas1504@gmail.com",
      Contact: 7498448558,
      "Insti Email": "swastikdas@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087453494576",
      LinkedIn: "www.linkedin.com/in/swastik-kumar-das-877976267",
    },
    {
      RollNo: "22EE10006",
      Name: "Ambati Jahnavi",
      Category: "Secretary",
      Post: "Secretary Innovation Cup",
      img: "22EE10006.jpg",
      Email: "Ambatijanu1234@gmail.com",
      Contact: 6305825572,
      "Insti Email": "Luckyjanu143@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087207802084&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/ambati-jahnavi-11659a249",
    },
    {
      RollNo: "22AR10002",
      Name: "Ayush Kumar",
      Category: "Secretary",
      Post: "Secretary Strategy Cup",
      img: "22AR10002.jpg",
      Email: "akyushumar@gmail.com",
      Contact: 9057738060,
      "Insti Email": "akyushumar@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100088638757729",
      LinkedIn: "https://www.linkedin.com/in/akyushumar/",
    },
    {
      RollNo: "22HS10056",
      Name: "Tarpan Kumar Das",
      Category: "Secretary",
      Post: "Secretary Application Cup",
      img: "22HS10056.png",
      Email: "tapastumpatattu@gmail.com",
      Contact: 8910337281,
      "Insti Email": "tarpan@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100089863226577",
      LinkedIn: "https://www.linkedin.com/in/tarpan-kumar-das-b84b75233/",
    },
    {
      RollNo: "22ME10090",
      Name: "Udish Jangid",
      Category: "Secretary",
      Post: "Secretary Knowledge Cup",
      img: "22ME10090.jpg",
      Email: "udishj@gmail.com",
      Contact: 8854818711,
      "Insti Email": "udishjangid@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/udish.jangid?mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/udish-jangid-45902611b",
    },
    {
      RollNo: "22CH10003",
      Name: "Aditya Deep",
      Category: "Secretary",
      Post: "Secretary Web",
      img: "22CH10003.jpg",
      Email: "adityadeep3007@gmail.com",
      Contact: 8603847976,
      "Insti Email": "adityadeep@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100094091247173",
      LinkedIn: "https://www.linkedin.com/in/deepaditya",
    },
    {
      RollNo: "22EX10050",
      Name: "Yogansh Sharma",
      Category: "Secretary",
      Post: "Secretary Web",
      img: "22EX10050.jpg",
      Email: "yoganshsharma65@gmail.com",
      Contact: 8742004884,
      "Insti Email": "yogansh@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087555068602",
      LinkedIn: "https://www.linkedin.com/in/yogansh-sharma-3ba506259",
    },
    {
      RollNo: "22MI10009",
      Name: "Akash Manna",
      Category: "Secretary",
      Post: "Secretary Web",
      img: "22MI10009.jpg",
      Email: "Akash.Manna2003@gmail.com",
      Contact: 8282901570,
      "Insti Email": "iamakashmanna@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/akash.manna.3591",
      LinkedIn: "https://www.linkedin.com/in/akash-manna-825278258/",
    },
    {
      RollNo: "22EE10074",
      Name: "Adarsh Tadiparthi",
      Category: "Secretary",
      Post: "Secretary Web",
      img: "22EE10074.jpg",
      Email: "adarshtadiparthi30@gmail.com",
      Contact: 9390004880,
      "Insti Email": "adarshtadiparthi30@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087676355082",
      LinkedIn: "https://www.linkedin.com/in/adarsh-tadiparthi-1b9962268/",
    },
    {
      Name: "Somya Bhadada",
      RollNo: "22MF3IM24",
      img: "22MF3IM24.jpg",
      Category: "Secretary",
      Post: "Secretary Media and Public Relations",
      Contact: 6375327292,
      Email: "bhadadasomya@gmail.com",
      "Insti Email": "bhadadasomya7@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=61550019015697",
      LinkedIn: "https://www.linkedin.com/in/somya-bhadada-65733a255",
    },
    {
      Name: "Palak Kothari",
      RollNo: "22GG10029",
      img: "22GG10029.jpg",
      Category: "Secretary",
      Post: "Secretary Media and Public Relation",
      Contact: 8302768822,
      Email: "Palakkothari256@gmail.com",
      "Insti Email": "Palakothari2506@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100085874270839&mibextid=9R9pXO",
      LinkedIn: "https://www.linkedin.com/in/palak-kothari-154917257",
    },
    {
      Name: "Bhumika Marmat",
      RollNo: "22MA10015",
      Category: "Secretary",
      Post: "Secretary Media and Content Writing ",
      img: "22MA10015.jpg",
      Contact: 8827033615,
      Email: "mikabhu.matmar@gmail.com",
      "Insti Email": "bhumikamarmat@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100086264551245&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/smartpeople01",
    },
    {
      Name: "Riya Salunkhe",
      RollNo: "22HS10045",
      Category: "Secretary",
      Post: "Institute Girl Sports' Secretary",
      img: "22HS10045.jpg",
      Contact: 9403138004,
      Email: "riyasalunkhe084@gmail.com",
      "Insti Email": "riya084@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087753902819&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/riya-salunkhe-b78599216",
    },
    {
      Name: "Simran Jangral",
      RollNo: "22GG10049",
      Category: "Secretary",
      Post: "Institute Girl Sports' Secretary",
      img: "22GG10049_1.jpg",
      Contact: 9797966096,
      Email: "simranjangral975@gmail.com",
      "Insti Email": "simranjangral@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087633905026&mibextid=9R9pXO",
      LinkedIn: "https://www.linkedin.com/in/simran-jangral-a17616234",
    },
    {
      Name: "Harshit Pathak",
      RollNo: "22IE10026",
      Category: "Secretary",
      Post: "Secretary Scholastic and Literary Subcommittee",
      img: "22IE10026.jpg",
      Contact: 8005443332,
      Email: "pathak.harshit1008@gmail.com",
      "Insti Email": "harshit.pathak@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/harshit.pathak.7359?mibextid=D4KYlr",
      LinkedIn: "https://www.linkedin.com/in/harshit-pathak-4b053524a",
    },
    {
      Name: "Pragya Bhootra",
      RollNo: "22CY10040",
      Category: "Secretary",
      Post: "Secretary Design",
      img: "22CY10040.png",
      Contact: 7737048976,
      Email: "Pbhootra2005@gmail.com",
      "Insti Email": "pbhootra2005@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100092295873299",
      LinkedIn: "www.linkedin.com/in/pragya-bhootra-333bb2258",
    },
    {
      Name: "Mragank Bhikshu",
      RollNo: "22AG30025",
      Category: "Secretary",
      Post: "Secretary Design",
      img: "22AG30025.jpg",
      Contact: 7500953738,
      Email: "mragankbhikshu@gmail.com",
      "Insti Email": "mragankbhikshu@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100090017360694",
      LinkedIn: "https://www.linkedin.com/in/mragank-bhikshu-219787256/",
    },
    {
      Name: "Gurram Hariprasad Chaitanya ",
      RollNo: "122CE30011",
      Category: "Secretary",
      Post: "Secretary Design ",
      img: "22CE30011_1.jpg",
      Contact: 8341300534,
      Email: "hariprasadchaitanya@gmail.com",
      "Insti Email": "hariprasadchaitanya@kgpian.iitkgp.ac.in",
      Facebook:
        "https://www.facebook.com/profile.php?id=100087638168413&mibextid=ZbWKwL",
      LinkedIn: "https://www.linkedin.com/in/hpiitkgp",
    },
    {
      Name: "Bhuvan Raj Guguloth",
      RollNo: "22ME30023",
      Category: "Secretary",
      Post: "Secretary Design",
      img: "22ME30023.jpg",
      Contact: 9392885490,
      Email: "bhuvanrajnaik@gmail.com",
      "Insti Email": "Bhuvanrajnaik@kgpian.iitkgp.ac.in",
      Facebook: "https://www.facebook.com/profile.php?id=100087754440241",
      LinkedIn: "https://www.linkedin.com/in/bhuvanrajguguloth05/",
    },
    {
      Name: "Omprakash Rathlavath",
      RollNo: "22CH30026",
      Category: "Secretary",
      Post: "Secretary Photography",
      img: "22CH30026.jpg",
      Contact: 6300743450,
      Email: "omprakashrathlavath@gmail.com",
      "Insti Email": "omprakash02@gmail.com",
      Facebook: "https://www.facebook.com/rathlavath.omprakash?mibextid=2JQ9oc",
      LinkedIn:
        "https://www.linkedin.com/in/om-prakash-rathlavath-8b705726a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    },
  ],
};
